export default ":host {\n  display: table;\n  border-collapse: collapse;\n  border-spacing: 0;\n  max-width: calc(100% + 5rem);\n  margin: 0 -2.5rem;\n}";